import { render } from "./DiagramLegend.vue?vue&type=template&id=21aff8d6&scoped=true"
import script from "./DiagramLegend.vue?vue&type=script&lang=js"
export * from "./DiagramLegend.vue?vue&type=script&lang=js"

import "./DiagramLegend.vue?vue&type=style&index=0&id=21aff8d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21aff8d6"]])

export default __exports__